export default __webpack_public_path__ + "static/media/ekran4_tlo.8a54ede6.png";